__turbopack_context__.v({
  "calendarLink": "_0GtuRq_calendarLink",
  "cta": "_0GtuRq_cta",
  "info": "_0GtuRq_info",
  "meta": "_0GtuRq_meta",
  "metaDate": "_0GtuRq_metaDate",
  "metaIcon": "_0GtuRq_metaIcon",
  "metaItem": "_0GtuRq_metaItem",
  "metaText": "_0GtuRq_metaText",
  "metaTime": "_0GtuRq_metaTime",
  "priceRow": "_0GtuRq_priceRow",
  "priceRowOffer": "_0GtuRq_priceRowOffer",
  "priceValue": "_0GtuRq_priceValue",
  "purchase": "_0GtuRq_purchase",
  "section": "_0GtuRq_section",
  "title": "_0GtuRq_title",
  "visible": "_0GtuRq_visible",
  "wrap": "_0GtuRq_wrap",
  "wrapSpacious": "_0GtuRq_wrapSpacious",
});
